import { clearForethoughtLocalData } from "../global/forethought-integration.util.js";

(function () {
    function HLoginManager() {
        var self = this, msgBus = new MsgBus();
        let messagesListener;
        let interval;
        self.init = function () {
            return new Promise(function (resolve, reject) {
                if (!publicConfiguration.isOAuthEnabled()) {
                    resolve();
                } else {
                    msgBus.init().then(function () {
                        resolve();
                    });
                }
            });
        };

        self.login = function (username, password, validationData) {
            validationData = validationData || {};
            return msgBus.method('login').params({
                username: username,
                password: password,
                validationData: validationData
            }).exec();
        };

        self.sendCustomChallengeAnswer = function (answer) {
            return msgBus.method('sendCustomChallengeAnswer').params(answer).exec();
        };

        self.isLoggedIn = function () {
            return new Promise(function (resolve, reject) {
                self.getToken().then(function (token) {
                    resolve(token && typeof token === "string");
                }, function (err) {
                    reject(err);
                });
            });
        };

        self.getToken = function () {
            return new Promise(function (resolve, reject) {
                if (!publicConfiguration.isOAuthEnabled()) {
                    resolve('');
                    return;
                }
                msgBus.method('getToken').exec().then(function (data) {
                    var token = data['token'] || HStorageManager.get({
                        storageLevel:  HStorageManager.StorageLevels.SESSION,
                        key: 'magicLinkToken'
                    });
                    resolve(token);
                }, function (err) {
                    reject(err);
                });
            });
        };

        self.isImpersonating = () => {
            return new Promise(function (resolve, reject) {
                if (!publicConfiguration.isOAuthEnabled()) {
                    resolve();
                    return;
                }

                return msgBus.method('isImpersonating')
                    .exec()
                    .then((data) => {
                        resolve(data.isImpersonating);
                    })
                    .catch(reject);
            });
        };

        self.resetPassword = function (email) {
            // return await msgBus.method('login').params(params).exec();
        };

        self.getActiveSessionKey = () => {
            return new Promise(function (resolve, reject) {
                if (!publicConfiguration.isOAuthEnabled()) {
                    resolve('');
                    return;
                }
                msgBus.method('getActiveSessionKey')
                    .exec()
                    .then((res) => {
                        resolve(res.username);
                    })
                    .catch(reject);
            });
        };

        self.signOut = function (forceRedirectTo, ref) {
            clearForethoughtLocalData();
            const brand = HStorageManager.get({
                key: "client_id",
                storageLevel: HStorageManager.StorageLevels.COOKIES
            });
            if (environmentsConfig.getEnv().host !== environmentsConfig.TEAM_SCHEDULE) {
                return new Promise(async function(resolve, reject){
                    const params = new URLSearchParams();
                    if (brand) {
                        params.set('brand', brand);
                    }
                    if (forceRedirectTo) {
                        params.set('redirectAfterLogout', encodeURIComponent(forceRedirectTo));
                    }
                    if (ref) {
                        params.set('ref', ref);
                    }
                    Utils.redirectToWorkspace(undefined, undefined,`/user/logout?${params.toString()}`)
                    resolve();
                });
            }
            var hUser = $injector.get('hUser');
            var $state = $injector.get('$state');
            return new Promise(function(resolve, reject){
                var redirectTo = $state.href('homepage', {brand: brand}, {absolute: true});
                if (HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'isQSRLogin'
                })) {
                    redirectTo = $state.href('qsr-login', {}, {absolute: true});
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'isQSRLogin',
                        value: ''
                    });
                }
                if (HStorageManager.get({
                    storageLevel:  HStorageManager.StorageLevels.SESSION,
                    key: 'magicLinkToken'
                })) {
                    HStorageManager.put({
                        storageLevel:  HStorageManager.StorageLevels.SESSION,
                        key: 'magicLinkToken',
                        value: ''
                    });
                }
                if (HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'customWelcomePageShown'
                })) {
                    HStorageManager.remove({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'customWelcomePageShown'
                    });
                }

                hUser.logout().then(function(){
                    msgBus.method('getRefreshToken').exec().then(function (refreshToken){
                        if(refreshToken.success && refreshToken.token){
                            UserAPI.markAsInvalidToken(refreshToken.token).then(function (resp) {
                                msgBus.method('signOut').exec().then(function (){
                                    resolve();
                                    window.location.href = forceRedirectTo || redirectTo;
                                });
                            });
                        }
                        else {
                            msgBus.method('signOut').exec().then(function (){
                                resolve();
                                window.location.href = forceRedirectTo || redirectTo;
                            });
                        }
                    });
                });
            });
        };

        self.signUp = function (email, password, phone_number, validationData) {
            return msgBus.method('signUp').params({
                email: email,
                password: password,
                phone_number: phone_number,
                validationData: validationData || {}
            }).exec();
        };

        self.changePassword = function (oldPassword, newPassword) {
            return msgBus.method('changePassword').params({
                oldPassword: oldPassword,
                newPassword: newPassword,
            }).exec();
        };

        self.regenerateUserTokens = function (oldPassword, newPassword) {
            return msgBus.method('regenerateToken').exec();
        };

        self.invalidateUserTokens = function(){
            return new Promise(function (resolve, reject){
                msgBus.method('getRefreshToken').exec().then(function (refreshToken){
                    if(refreshToken.success && refreshToken.token){
                        UserAPI.markAsInvalidToken(refreshToken.token).then(function (resp) {
                            resolve();
                        }, function () {
                            reject();
                        });
                    }
                    else {
                        reject();
                    }
                });
            });
        };


        self.getFederateSignInLink = function (provider) {
            return new Promise(function (resolve, reject) {
                msgBus.method('federate').params({
                    provider: provider
                }).exec().then(function (res) {
                    if (res.success) {
                        resolve(res.redirectUrl)
                    }
                }, function (err) {
                    reject(err);
                });
            });
        }

        self.getLoginTime = function () {
            return new Promise(function (resolve, reject) {
                msgBus.method('getLoginTime').params({}).exec().then(function (res) {
                    if (res.success) {
                        resolve(res.loginTime)
                    }
                }, function (err) {
                    reject(err);
                });
            });
        }

        self.isFederatedSignInInProgress = false;
        self.loggedInUsingFederatedSignIn = false;
        self.federatedSignIn = function (provider) {
            self.isFederatedSignInInProgress = true;
            return new Promise(function (resolve, reject) {
                self.getFederateSignInLink(provider).then(function (redirectUrl){
                    var popup = window.open(redirectUrl, '_blank', 'width=600px,height=600px');
                    var once=false;

                    // grab the window to user focus if he click on the shaded area
                    $('.social-loading, .social-login-loading').off('click').click(function(){
                        popup? popup.focus(): null;
                    });

                    interval = window.setInterval(function() {
                        try {
                            if (popup == null || popup.closed) {
                                window.clearInterval(interval);
                                if(!once){
                                    resolve({
                                        closed: true,
                                    });
                                    self.isFederatedSignInInProgress = false;
                                }
                            }
                        }
                        catch (e) {

                        }
                    }, 2000);

                    messagesListener = window.addEventListener('message', function (e) {
                        if(e.data.isSocialLogin && !once){
                            once=true;
                            window.clearInterval(interval);
                            window.removeEventListener("message", messagesListener);
                            popup.close();
                            if(e.data.success === true && e.data.hasOwnProperty('isNewUser')){
                                self.isFederatedSignInInProgress = false;
                                self.loggedInUsingFederatedSignIn = true;
                                resolve(e.data);
                            }
                            else if(e.data.success === true && !e.data.hasOwnProperty('isNewUser')){
                                hLog('FEDERATED_REGISTRATION', 'API_FAILED', e.data);
                                self.isFederatedSignInInProgress = false;
                                self.loggedInUsingFederatedSignIn = true;
                                resolve({error: true, details: 'Something went wrong'});
                            }
                            else if(e.data.details){
                                // api error
                                hLog('FEDERATED_REGISTRATION', 'API', e.data);
                                resolve({error: true, details: e.data.details});
                                self.isFederatedSignInInProgress = false;
                            }
                            else if(e.data.error){
                                hLog('FEDERATED_REGISTRATION', 'OTHER_ERROR', e.data);
                                resolve({error: true, details: e.data});
                                self.isFederatedSignInInProgress = false;
                            }
                        }
                    }, false);
                }, function (err) {
                    reject(err);
                });
            });
        };

        // used to check if we can redirect user on login
        self.canRedirectIfLoggedIn = function () {
            return !self.isFederatedSignInInProgress && !self.loggedInUsingFederatedSignIn;
        };

        self.reset = function() {
            window.clearInterval(interval);
            window.removeEventListener("message", messagesListener);
            msgBus.reset();
            return self.init();
        }
    }

    window['hLoginManager'] = new HLoginManager();
    window['hLoginManager'].init();
})();

// (function(hLoginManager){
//     hLoginManager.init().then(function(){
//
//     })
// })(new HLoginManager())

